
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/headless/indicators",
      function () {
        return require("private-next-pages/x/react-chat/headless/indicators.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/headless/indicators"])
      });
    }
  